export default __webpack_public_path__ + "static/standtogther-7fbf470d9fa7b8252d53ba76334e9ba9.svg";